import fetchRoofTypes from './fetchRooftTypes';
import filterItems from './filterItems';

export default (filterData) => (dispatch) => {
    Promise.all([
        dispatch(fetchRoofTypes()),
        dispatch(filterItems(filterData)),
    ]);
};
